// убираем лишние символы из строки с почтой
export const sanitizeEmail = (email: string) =>
  email.trim().replace(/\s+/g, "");
